import { RiskBaseGlobal } from 'components/App/Global';
import { storage } from './storage';

type ReduxStorage = {
  setItem: (key: string, value: string) => Promise<void>;
  getItem: (key: string) => Promise<string>;
  removeItem: (key: string) => Promise<void>;
};

const setItemDelay: Record<string, undefined | ReturnType<typeof setTimeout>> =
  {};

export const ReduxPersistStorage: ReduxStorage = {
  getItem: async (filename) => {
    return storage.readStringFile({ filename });
    /**
     * Data coming out of storage may be stringified once or twice (bad!).
     * If the data is stringified twice, we should return the parsed version.
     * --
     * In old native versions, we stringified befor persisting. This was wrong
     * because redux-persist already stringifies itself. New native versions no
     * longer stringify when saving.
     * --
     * @remove 2022-07-01 - this change was made around 2022-01-27. If we remove
     * this check, and a user hasn't used the app since the change, it may break.
     */
    // const item = await storage.getStringItem(key);
    // const parsedItem = JSON.parse(item);
    // return typeof parsedItem === 'string' ? parsedItem : item;
  },

  setItem: async (filename, value) => {
    if (__DEV__) {
      storage.writeStringFile({ filename, data: value }).catch((error) => {
        RiskBaseGlobal.reduxPersistError = error;
      });
    } else {
      if (setItemDelay[filename]) {
        clearTimeout(setItemDelay[filename]!);
        setItemDelay[filename] = undefined;
      }
      setItemDelay[filename] = setTimeout(() => {
        storage.writeStringFile({ filename, data: value }).catch((error) => {
          RiskBaseGlobal.reduxPersistError = error;
        });
      }, 1000);
    }
  },

  removeItem: async (filename) => {
    return storage.deleteFile({ filename });
  },
};
